<template>
	<div class="page" data-name="parent-regist">		
		<div class="page-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					학부모 회원가입
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
    	</f7-navbar>
			<div class="block-title">※ 서비스 이용약관 및 개인정보 수집 및 이용</div>
			<div class="list">
    		<ul>
        	<li>
   				 	<a href="#" class="item-link item-content popup-open" data-popup=".term-use-popup"> 
							<div class="item-inner">
            		<div class="item-title">서비스 이용약관 내용확인</div>
								<div class="item-after">{{termUseAgreement ? '동의' : '미동의'}}</div>
        			</div>
    				</a>
					</li>
					<li>
   				 	<a href="#" class="item-link item-content popup-open" data-popup=".privacy-popup">
							<div class="item-inner">
            		<div class="item-title">개인정보 수집 및 이용 내용확인</div>
								<div class="item-after">{{privacyAgreement ? '동의' : '미동의'}}</div>
        			</div>
    				</a>
					</li>
    		</ul>
		  </div>

			
			<div class="block-title">*정보 입력</div>
			<div class="list no-hairlines">
				<ul>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">							
							<div class="item-input-wrap">
								<input type="text" name="userName" ref="userName" :value="userName" readonly disabled>								
							</div>
						</div>
    			</li>								
					<li class="item-content item-input item-input-outline row">     																
						<div class="item-inner">														
							<div class="item-input-wrap">
								<input type="text" name="userId" ref="userId" :value="mobile" readonly disabled>								
							</div>																										
						</div>														
					</li>							
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">패스워드 입력</div>
							<div class="item-input-wrap">
								<input type="password" name="userPw" ref="userPw">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">입력한 비밀번호확인</div>
							<div class="item-input-wrap">
								<input type="password" name="userPwConfirm" ref="userPwConfirm">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>								
				</ul>
			</div>

			<div class="block-title">자녀 추가</div>
			<div class="list no-hairlines">
				<ul>
					<li class="item-content item-input item-input-outline row">     										
						<div class="col-60">
							<div class="item-inner">							
								<div class="item-title item-floating-label">자녀 코드 입력</div>
								<div class="item-input-wrap">
									<input type="text" name="childCode" ref="childCode" :maxlength="maxCodeLength">
									<span class="input-clear-button"></span>
								</div>																										
							</div>	
						</div>
						<div class="col-40">								
							<div class="item-inner">																
								<button class="button button-outline" v-on:click="checkChildCode" >추가</button>											
							</div>			
						</div>						
					</li>
					<li>
						<div class="list">							
							<ul>
								<template  v-for="(item,i) in childList">																		
									<li :key="'ii' + i" >	
										<div class="item-content">
											<div class="item-media">
												<i class="f7-icons">arrow_turn_down_right</i>
											</div>
											<div class="item-inner">
												<div class="item-title">
													{{item.userName}} {{item.birthDate}} 추가 완료
												</div>
											</div>
										</div>																									
									</li>
								</template>
							</ul>
						</div>
					</li>		
					<li class="item-content item-input item-input-outline">
						<div class="item-inner">				
							<button class="button button-fill " ref="join" v-on:click="addParentUser">가입하기</button>				
						</div>
					</li>							
				</ul>
			</div>

		</div>
		<!-- 서비스 이용약관 -->
		<div class="popup term-use-popup" id="term-use-popup">
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">서비스 이용약관</div>
							<div class="right">
								<!-- Link to close popup -->
								<a class="link popup-close">닫기</a>
							</div>
						</div>
					</div>
					<div class="page-content">		
						<div class="block-title">제 1 조 (목적)</div>
						<div class="block">
							이 약관은 <strong>(주)오투라인 ("회사" 또는 "오투라인")가 제공하는 벤숲 및 벤자민의숲 관련 제반 서비스의 이용과 관련하여 회사와 회원과의 권리, 의무 및 
							책임사항, 기타 필요한 사항을 규정함을 목적</strong>으로 합니다.
						</div>	
						<div class="block-title">제 2 조 (정의)</div>		
						<div class="block">	
							이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br />							
							<div class="list no-hairlines">
          			<ul>
            			<li>①"서비스"라 함은 구현되는 단말기(PC, 모바일기기 등의 각종 유무선 장치를 포함)와 상관없이 "회원"이 이용할 수 있는 벤숲 및 벤자민의숲 관련 제반 서비스를 의미합니다.</li>
									<li>②"회원"이라 함은 회사의 "서비스"에 접속하여 이 약관에 따라 "회사"와 이용계약을 체결하고 "회사"가 제공하는 "서비스"를 이용하는 고객을 말합니다.</li>
									<li>③"아이디(ID)"라 함은 "회원"의 식별과 "서비스" 이용을 위하여 "회원"이 정하고 "회사"가 승인하는 문자와 숫자의 조합을 의미합니다.</li>									
									<li>④"비밀번호"라 함은 "회원"이 부여 받은 "아이디와 일치되는 "회원"임을 확인하고 비밀보호를 위해 "회원" 자신이 정한 문자 또는 숫자의 조합을 의미합니다.</li>																			
									<li>⑤"이용자 생성 정보"이라 함은 "회원"이 "서비스"를 이용함에 있어 "서비스상"에 게시한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 시험지 정보 및 문항 선택정보 등을 의미합니다.</li>
          			</ul>
							</div>
						</div>
						<div class="block-title">제 3 조 (약관의 게시와 개정)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회사"는 이 약관의 내용을 "회원"이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.</li>
									<li>②"회사"는 "약관의규제에관한법률", "정보통신망이용촉진및정보보호등에관한법률(이하 "정보통신망법")" 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
									<li>③"회사"가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 30일 전부터 적용일자 전일까지 공지합니다.</li>
									<li>④회사가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.</li>
									<li>⑤회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을 해지할 수 있습니다.</li>				
								</ul>
							</div>
						</div>
						<div class="block-title">제 4 조 (이용계약 체결)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①이용계약은 "회원"이 되고자 하는 자(이하 "가입신청자")가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 "회사"가 이러한 신청에 대하여 승낙함으로써 체결됩니다.</li>
									<li>
										<p>②"회사"는 "가입신청자"의 신청에 대하여 "서비스" 이용을 승낙함을 원칙으로 합니다. 다만, "회사"는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.</p>
										<div class="list no-hairlines">
											<ul style="padding-left:5px;">
												<li>1.가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 "회사"의 회원 재가입 승낙을 얻은 경우에는 예외로 함.</li>
												<li>2.실명이 아니거나 타인의 명의를 이용한 경우</li>
												<li>3.허위의 정보를 기재하거나, "회사"가 제시하는 내용을 기재하지 않은 경우</li>											
												<li>4.이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
											</ul>
										</div>
									</li>
									<li>③제1항에 따른 신청에 있어 "회사"는 "회원"의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.</li>
									<li>④"회사"는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.</li>
									<li>⑤제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, "회사"는 원칙적으로 이를 가입신청자에게 알리도록 합니다.</li>
									<li>⑥이용계약의 성립 시기는 "회사"가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.</li>
									<li>⑦"회사"는 "회원"에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.</li>
									<li>⑧"회사"는 "회원"에 대하여 "영화및비디오물의진흥에관한법률" 및 "청소년보호법"등에 따른 등급 및 연령 준수를 위해 이용제한이나 등급별 제한을 할 수 있습니다.</li>
								</ul>
							</div>
						</div>
						<div class="block-title">제 5 조 (회원정보의 변경)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회원"은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.</li>
									<li>②"회원"은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 "회사"에 대하여 그 변경사항을 알려야 합니다.</li>
									<li>③제2항의 변경사항을 "회사"에 알리지 않아 발생한 불이익에 대하여 "회사"는 책임지지 않습니다.</li>
								</ul>
							</div>
						</div>
						<div class="block-title">제 6 조 (개인정보보호 의무)</div>		
						<div class="block">	
							"회사"는 "정보통신망법" 등 관계 법령이 정하는 바에 따라 "회원"의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 "회사"의 개인정보취급방침이 적용됩니다.
						</div>
						<div class="block-title">제 7 조 ("회원"의 "아이디" 및 "비밀번호"의 관리에 대한 의무)</div>		
						<div class="block">
							<div class="list no-hairlines">
								<ul>
									<li>①"회원"의 "아이디"와 "비밀번호"에 관한 관리책임은 "회원"에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.</li>
									<li>②"회사"는 "회원"의 "아이디"가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 "회사" 및 "회사"의 운영자로 오인한 우려가 있는 경우, 해당 "아이디"의 이용을 제한할 수 있습니다.</li>
									<li>③"회원"은 "아이디" 및 "비밀번호"가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 "회사"에 통지하고 "회사"의 안내에 따라야 합니다.</li>
									<li>④제3항의 경우에 해당 "회원"이 "회사"에 그 사실을 통지하지 않거나, 통지한 경우에도 "회사"의 안내에 따르지 않아 발생한 불이익에 대하여 "회사"는 책임지지 않습니다.</li>
								</ul>
							</div>	
						</div>
						<div class="block-title">제 8 조 ("회사"의 의무)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회사"는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 "서비스"를 제공하기 위하여 최선을 다하여 노력합니다.</li>
									<li>②"회사"는 "회원"이 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보취급방침을 공시하고 준수합니다.</li>
									<li>③"회사"는 서비스이용과 관련하여 발생하는 이용자의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및 시스템을 구비합니다.</li>
									<li>④"회사"는 서비스이용과 관련하여 "회원"으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. "회원"이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 "회원"에게 처리과정 및 결과를 전달합니다.</li>
								</ul>
							</div>
						</div>
						<div class="block-title">제 9 조 ("회원"의 의무)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>
										①"회원"은 다음 행위를 하여서는 안 됩니다.
										<div class="list no-hairlines">
											<ul style="padding-left:5px;">
												<li>1.신청 또는 변경 시 허위내용의 등록<li>
												<li>2.타인의 정보도용<li>	
												<li>3.이용자ID를 제3자에게 제공 및 공유</li>
												<li>4."회사"가 게시한 정보의 변경</li>
												<li>5."회사"와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
												<li>6."회사" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
												<li>7.외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 "서비스"에 공개 또는 게시하는 행위</li>
												<li>8.회사의 동의 없이 영리를 목적으로 "서비스"를 사용하는 행위</li>
												<li>9.기타 불법적이거나 부당한 행위</li>
											</ul>
										</div>
									</li>
									<li>②"회원"은 관계법, 이 약관의 규정, 이용안내 및 "서비스"와 관련하여 공지한 주의사항, "회사"가 통지하는 사항 등을 준수하여야 하며, 기타 "회사"의 업무에 방해되는 행위를 하여서는 안 됩니다.</li>
								</ul>
							</div>
						</div>
						<div class="block-title">제 10 조 ("서비스"의 제공 등)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>
										①회사는 회원에게 아래와 같은 서비스를 제공합니다.
										<div class="list no-hairlines">
											<ul style="padding-left:5px;">
												<li>1.온라인 평가 및 학습 서비스</li>
												<li>2.자료실 및 게시판 서비스</li>
												<li>3.기타 "회사"가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 "회원"에게 제공하는 일체의 서비스</li>
											</ul>
										</div>
									</li>
									<li>②회사는 "서비스"를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.</li>
									<li>③"서비스"는 매일 정기 점검 시간(02:00 ~ 08:00)를 제외한 시간을 연중무휴로 제공함을 원칙으로 합니다.</li>
									<li>④"회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 "서비스"의 제공을 일시적으로 중단할 수 있습니다. 이 경우 "회사"는 제9조["회원"에 대한 통지]에 정한 방법으로 "회원"에게 통지합니다. 다만, "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</li>
									<li>⑤"회사"는 서비스의 제공에 필요한 경우 별도 정기점검을 실시할 수 있으며, 별도 정기점검시간은 서비스제공 화면에 공지합니다.</li>									
								</ul>
							</div>
						</div>
						<div class="block-title">제 11 조 ("서비스"의 변경)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회사"는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 변경할 수 있습니다.</li>
									<li>②"서비스"의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.</li>
									<li>③"회사"는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 "회원"에게 별도의 보상을 하지 않습니다.</li>
								</ul>
							</div>
						</div>
						<div class="block-title">제 12 조 ("이용자 생성 정보"의 관리)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회원"의 "게시물"이 "정보통신망법" 및 "저작권법"등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법이 정한 절차에 따라 해당 "이용자 생성 정보"의 게시중단 및 삭제 등을 요청할 수 있으며, "회사"는 관련법에 따라 조치를 취하여야 합니다.</li>
									<li>②"회사"는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 "게시물"에 대해 임시조치 등을 취할 수 있습니다.</li>
									<li>③"회사"는 서비스 관리 및 시스템 관리의 효율을 위하여, 이용자 생성 정보를 주기적으로 삭제할 수 있습니다. "회원"의 "이용자 생성 정보"중 지속적인 보관이 따로 필요한 경우는 "회사"에 별도로 요청 할 수 있습니다.</li>									
								</ul>
							</div>
						</div>
						<div class="block-title">제 13 조 (권리의 귀속)</div>		
						<div class="block">
							<div class="list no-hairlines">
								<ul>
									<li>①"서비스"에 대한 저작권 및 지적재산권은 "회사"에 귀속됩니다. 단, "회원"의 "이용자 생성 정보" 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.</li>
									<li>②"회사"는 서비스와 관련하여 "회원"에게 "회사"가 정한 이용조건에 따라 계정, "아이디", 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, "회원"은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.</li>
								</ul>
							</div>	
						</div>
						<div class="block-title">제 14 조 (계약해제, 해지 등)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회원"은 언제든지 서비스초기화면의 고객센터 또는 내 정보 관리 메뉴 등을 통하여 이용계약 해지 신청을 할 수 있으며, "회사"는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.</li>
									<li>②"회원"이 계약을 해지할 경우, 관련법 및 개인정보취급방침에 따라 "회사"가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 "회원"의 모든 데이터는 소멸됩니다.</li>
									<li>③"회원"의 모든 정보는 "회원"이 속한 조직(학원,학교,기타 업체)에서 서비스 해지를 요청한 기일로 부터 2개월간 회원정보를 보관하며, 보관 기일이 종료되면 "회사"는 지체없이 전자적인 방법으로 회원의 개인정보를 삭제 처리 합니다.</li>
								</ul>
							</div>
						</div>
						<div class="block-title">제 15 조 (이용제한 등)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회사"는 "회원"이 이 약관의 의무를 위반하거나 "서비스"의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 "서비스" 이용을 단계적으로 제한할 수 있습니다.</li>
									<li>②"회사"는 전항에도 불구하고, 명의도용 및 결제도용, "저작권법" 및 "컴퓨터프로그램보호법"을 위반한 불법프로그램의 제공 및 운영방해, "정보통신망법"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 "서비스" 이용을 통해 획득한 모든 자료와 혜택 혜택 등도 모두 소멸되며, "회사"는 이에 대해 별도로 보상하지 않습니다.</li>
									<li>③"회원"은 본 조에 따른 이용제한 등에 대해 "회사"가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 "회사"가 인정하는 경우 "회사"는 즉시 "서비스"의 이용을 재개합니다.</li>									
								</ul>
							</div>
						</div>
						<div class="block-title">제 16 조 (책임제한)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul style="padding-left:5px;">
									<li>①"회사"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.</li>
									<li>②"회사"는 "회원"의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
									<li>③"회사"는 "회원"이 "서비스"와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</li>									
								</ul>
							</div>
						</div>
						<div class="block-title">제 17 조 (준거법 및 재판관할)</div>		
						<div class="block">	
							<div class="list no-hairlines">
								<ul>
									<li>①"회사"와 "회원" 간 제기된 소송은 대한민국법을 준거법으로 합니다.</li>
									<li>②"회사"와 "회원"간 발생한 분쟁에 관한 소송은 제소 당시의 "회원"의 주소에 의하고, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다. 단, 제소 당시 "회원"의 주소 또는 거소가 명확하지 아니한 경우의 관할법원은 민사소송법에 따라 정합니다.</li>
									<li>③해외에 주소나 거소가 있는 "회원"의 경우 "회사"와 "회원"간 발생한 분쟁에 관한 소송은 전항에도 불구하고 대한민국 서울중앙지방법원을 관할법원으로 합니다.</li>			
								</ul>
							</div>
						</div>
						<div class="block-title">부칙</div>		
						<div class="block">	
							이 약관은 <strong>2020년 11월 16일부터 적용</strong>됩니다.
						</div>
						<div class="list">
							<ul>
								<li>
									<label class="item-checkbox item-content">
										<div class="item-inner">
											<div class="item-title">서비스 이용약관에 동의 하십니까?</div>
										</div>
										<input type="checkbox" name="termAgreement" value="ok" v-on:change="teremCheck"/>
										<i class="icon icon-checkbox"></i>						
									</label>
								</li>
							</ul>
						</div>
					</div>
				
				</div>
			</div> 
		</div>

		<!--개인정보 수집 및 이용 내용 확인-->
		<div class="popup privacy-popup" id="privacy-popup">
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">개인정보 수집 및 이용내용확인</div>
							<div class="right">								
								<a class="link popup-close">닫기</a>
							</div>
						</div>
					</div>
					<div class="page-content">		
						<div class="block">	
							<p><strong>정보통신망법 관련 규정에 따라 회원가입을 신청하시는 분께 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다.</strong></p>
						</div>
						<div class="block-title">1. 수집하는 개인정보</div>
						<div class="block">
							<p>이용자는 회원가입을 해야 학습과 관련된 기능과 화면들을 이용할 수 있습니다. 원활한 서비스 이용과 이용자 개인별 시험출제 및 학습 결과등의 기능을 이용하기 위해 회원가입시 '벤자민의 숲'는 서비스 이용을 위해 필요한 최소한의 개인정보를 수집합니다.</p>
							<p><strong>회원가입시 이용자로 부터 수집하는 개인정보는 다음과 같습니다.</strong></p>
							<p>
								- 이름, 생년월일, 로그인ID, 비밀번호, 비밀번호 질문 답변을 필수 항목으로 수집합니다.<br>
								만약, 이용자가 입력하는 생년월일이 만14세 미만 아동일 경우, 법정대리인 정보를 추가로 수집합니다.<br>
								- 학생 휴대전화번호, 이메일, 집주소를 선택항목으로 수집합니다.<br>
							</p>
							<p><strong>서비스 이용과정에서 이용자로부터 수집하는 개인정보는 다음과 같습니다.</strong></p>
							<p>- PC 서비스 이용기록, PC 방문일시, PC 쿠키, PC 접속IP 정보, PC MAC address가 필수 항목으로 자동 수집됩니다.</p>
							<p>- 스마트기기 서비스 이용기록, 스마트기기 방문일시, 스마트기기 접속IP 정보, 스마트기기 MAC address가 자동 수집됩니다.</p>
						</div>
						<div class="block-title">2. 수집한 개인정보의 이용</div>
						<div class="block">
							<p><strong>'벤자민의 숲'는 회원관리, 서비스 개발・제공 및 고도화 등 원래 학습 서비스 제공의 목적으로만 개인정보를 이용합니다. </strong></p>
							<p>회원가입 연령 확인 및 법정대리인 동의 진행, 이용자 및 법정대리인의 본인 확인, 이용자 식별, 회원탈퇴 의사의 확인 등 회원관리를 위하여 개인정보를 이용합니다.</p>
							<p>학습 콘텐츠 및 시험 출제, 응시, 결과 분석 등의 학습 관련 서비스에서 학습 대상자를 구별하고 유기적인 서비스의 상호 소통 기능을 위해 개인정보를 이용합니다.</p>
							<p>법령 및 '벤자민의 숲' 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용 행위를 포함하여 학습 콘텐츠 및 시험 출제, 응시, 결과 분석 등의 학습 관련 서비스에서 학습 대상자를 구별하고 유기적인 서비스의 상호 소통 기능을 위해 개인정보를 이용합니다.</p>
							<p>서비스의 원활한 운영에 지장을 주는 행위에 대한 방지 및 제재, 계정도용 및 부정거래 방지, 약관 개정 등의 고지사항 전달, 분쟁조정을 위한 기록 보존, 민원처리 등 이용자 보호 및 서비스 운영을 위하여 개인정보를 이용합니다.</p>
							<p>서비스 이용기록과 접속 빈도 분석, 서비스 이용에 대한 통계, 서비스 분석 및 통계에 따른 맞춤 서비스 제공 및 광고 게재 등에 개인정보를 이용합니다.</p>
							<p>보안, 프라이버시, 안전 측면에서 이용자가 안심하고 이용할 수 있는 서비스 이용환경 구축을 위해 개인정보를 이용합니다.</p>
						</div>
						<div class="block-title">3. 개인정보의 파기</div>
						<div class="block">
							<p><strong>당사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.</strong>
							<p>① 서비스 이용 종료시 보존 개인정보</p>
							<div class="list no-hairlines">
								<ul>
									<li>보존항목: 이름, 생년월일, 로그인ID, 비밀번호, 비밀번호 질문 답변, 학생 휴대전화번호, 이메일, 집주소</li>
									<li>보존근거: 탈퇴 계정 복구</li>
									<li>보존기간: 서비스 이용 종료후 2개월</li>									
								</ul>
							</div>
							<p>② 웹사이트 방문 기록</p>
							<div class="list no-hairlines">
								<ul>
									<li>보존항목: PC 접속 IP 정보, PC Mac address, PC 방문 일시, 스마트기기 접속 IP 정보, 스마트기기 Mac address, 스마트기기  방문 일시</li>
									<li>보존근거: 통신 비밀 보호법</li>
									<li>보존기간: 3개월</li>
								</ul>
							</div>
						</div>
						<div class="list">
							<ul>
								<li>
									<label class="item-checkbox item-content">
										<div class="item-inner">
											<div class="item-title">개인정보 수집 및 이용 내용 동의 하십니까?</div>
										</div>
										<input type="checkbox" name="privacyAgreement" value="ok" v-on:change="privacyCheck"/>
										<i class="icon icon-checkbox"></i>						
									</label>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>	
	  <!--자녀 정보-->
		<div class="popup child-info-popup" id="child-info-popup">
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">정보</div>
							<div class="right">								
								<a class="link popup-close">취소</a>
							</div>
						</div>
					</div>
					<div class="page-content">	
						<div class="block-title block-title-medium">자녀정보를 확인 후 추가하세요.</div>	
						<div class="block list">
							<ul>
								<li class="item-content item-input item-input-outline">      
									<div class="item-inner">								
										학원명 :	{{childInfo.companyName}}
									</div>
								</li>
								<li class="item-content item-input item-input-outline">      
									<div class="item-inner">								
									이름 :	{{childInfo.userName}} ({{childInfo.gradeName}})										
									</div>
								</li>
								<li class="item-content item-input item-input-outline">      
									<div class="item-inner">								
									생년 월일 :	{{childInfo.birthDate}}
									</div>
								</li>
								<li class="item-content item-input item-input-outline">
									<div class="item-inner">				
										<button class="button button-fill " ref="addChild" v-on:click="addChild">추가</button>				
									</div>
								</li>			
							</ul>													
						</div>									
					</div>					
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import MODULE from '../../js/common/module.js'
	import Vue from 'vue';
	import { f7 } from 'framework7-vue';
  import CONST from '../../js/common/constant.js'
  import AUTH from '../../js/common/auth.js'
  import PAGES from '../../js/pages.js'
	import API from '../../js/common/api.js'	

	export default {
		data() {
			return {
				termUseAgreement: false,
				privacyAgreement: false,
				certNumber:"",
				userName: "",							
				companyKey: 0,			
				mobile: "",
				childList: [],
				childInfo: {
					userKey:0,
					userName: "",
					gradeName: "",
					birthDate: "",
					companyName: "",
					companyKey: 0				
				},
				maxCodeLength: 4
			};
		},
		mounted() {
			const _this = this;
			_this.userName = _this.$f7route.context.userName;	    
			_this.mobile = _this.$f7route.context.mobile;
			_this.certNumber = _this.$f7route.context.certNumber;
		},
		methods: {
			teremCheck(event) {
				const _this = this;   
				const element = event.currentTarget;

				if (element.checked) {												
					_this.termUseAgreement = true;					
					_this.$f7.popup.close("#term-use-popup", true);
				}else{
					_this.termUseAgreement = false;
				}
			},
			privacyCheck(event) {
				const _this = this;   
				const element = event.currentTarget;

				if (element.checked) {												
					_this.privacyAgreement = true;					
					_this.$f7.popup.close("#privacy-popup", true);
				}else{
					_this.privacyAgreement = false;
				}
			},  
			checkChildCode() {
				const _this = this;
				var childCode = _this.$refs.childCode.value;

				if(MODULE.Util.isEmpty(childCode)){
					MODULE.DialogBox.message("자녀코드를 입력하셔야 합니다.");
					return;
				}

				let param = {
					pChildCode : childCode.toUpperCase()
				}
								
				API.ajaxRequest({
					url: API.checkChildCode(),
					data: param
				}).then(function (data){					
					_this.openChildInfoPopup(data);
				}).catch(function (code){

					if(code == CONST.resultCode.EMPTY) {
						MODULE.DialogBox.message("일치하는 정보가 없습니다.");
						return;
					}else {
						MODULE.UITool.catchBlock(code, PAGES, AUTH);
					}
					
				});
								
			},	
			openChildInfoPopup(info) {
				const _this = this;
				_this.childInfo = _this.createChildObj();

				_this.childInfo.companyName = info.COMPANY_NAME;
				_this.childInfo.userKey = info.USER_KEY;
				_this.childInfo.userName = info.USER_NAME;
				_this.childInfo.gradeName = CONST.userGrade[info.USERGRADE_ID].name;
				_this.childInfo.companyKey = info.COMPANY_KEY;
				var birthDate = moment(info.BIRTH_DATE).format("YYYY-MM-DD");					
				_this.childInfo.birthDate = birthDate;
				_this.$f7.popup.open("#child-info-popup", true);	
			},	
			addChild() {
				const _this = this;
				var check = false;

				for(var i = 0; i < _this.childList.length; i++) {
					var info = _this.childList[i];

					if(info.userKey == _this.childInfo.userKey) {
						check = true;
						break;
					}
				}
				
				if(check){
					MODULE.DialogBox.message("이미 추가된 자녀입니다.");
					_this.$f7.popup.close("#child-info-popup", true);
					return;
				}				
				
				_this.companyKey = _this.childInfo.companyKey;
				_this.childList.push(_this.childInfo);
				_this.$f7.popup.close("#child-info-popup", true);
				_this.$refs.childCode.value = "";	
			},		
			createChildObj() {
				const _this = this;

				 var info = {		
					userKey:0,								
					userName: "",
					gradeName: "",
					birthDate: "",
					companyName: "",
					companyKey: 0						
				}

				return info;
			},
			addParentUser() {
				const _this = this;

				if(!_this.termUseAgreement){
					MODULE.DialogBox.warnToast("서비스 이용 약관에 동의하셔야 합니다.");
					return false;	
				}
				
				if(!_this.privacyAgreement){
					MODULE.DialogBox.warnToast("개인 정보 수집 및 이용에 동의하셔야 합니다.");
					return false;	
				}

				var userName = _this.$refs.userName.value;
				if(MODULE.Util.isEmpty(userName)){
					MODULE.DialogBox.warnToast("이름을 입력하셔야 합니다.");
					return false;	
				}
				
				var userId = _this.$refs.userId.value;
				if(MODULE.Util.isEmpty(userId)){
					MODULE.DialogBox.warnToast("아이디를 입력하셔야 합니다.");
					return false;	
				}

				var userPw = _this.$refs.userPw.value;
				if(MODULE.Util.isEmpty(userPw)){
					MODULE.DialogBox.warnToast("패스워드를 입력하세요.");
					return false;
				}

				if(MODULE.Util.checkPassWordReg(userPw) < 2){
					MODULE.DialogBox.warnToast("비밀번호는 영어 대문자, 영어 소문자, 숫자, 특수문자 중 2종류 이상으로 구성해야합니다.");				
					return false;
				}

				if(userPw != _this.$refs.userPwConfirm.value){
					MODULE.DialogBox.warnToast("입력한 패스워드가 틀립니다.");
					return false;
				}

				if(_this.companyKey == 0) {
					MODULE.DialogBox.warnToast("학원번호가 없습니다.");
					return false;
				}
				if(_this.childList.length == 0) {
					MODULE.DialogBox.warnToast("자녀를 추가하셔야 합니다.");
					return false;
				}
		
				let param = {
					userName         : userName,
					userId 	         : userId.replace(/\-/g,''),
					userPW 	 	       : userPw,							
					companyKey       : _this.companyKey,					
					mobile		       : _this.mobile,				
					userType 			 	 : "parent",
					certNumber 			 : _this.certNumber,
					childList 			 : _this.childList			
				}

				MODULE.JsonRequest.request({
					url: API.addParentUser(),
					data : JSON.stringify(param)
				}).then(function (data){
					PAGES.goPage(PAGES.LOGIN_PAGE);
				}).catch(function (code){
					
					if(code == CONST.resultCode.FAIL){
						MODULE.DialogBox.message("회원가입에 실패 하였습니다.");
					}else{
						if (code == CONST.resultCode.EMPTY) {
							MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다.<br/>코드를 확인하세요.");
						}
						MODULE.UITool.catchBlock(code, PAGES, AUTH);
					}
				});

			}
		}
	}
</script>